<template>
  <div class="home">
    <RequestPage />
  </div>
</template>

<script>
import RequestPage from '../components/elements/pages/RequestPage.vue'
export default {
  name: 'Request',
  metaInfo: {
    title: 'Request Kits'
  },
  components: {
    RequestPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
